import Vue from 'vue'
import { mapGetters } from 'vuex'

import ImportData from './ImportData'

import Icons from '@/module/add/icons'

import validEmail from '@/module/util/valid-email'
import formatDate from '@/module/util/format-date'

export default {
	name: 'import-patient-form-card',

	props: {
		patient: {
			type: Object,
			required: true
		},
		column: {
			type: Object,
			required: true
		},
		confirm: {
			type: Boolean,
			default: true
		},
		index: {
			type: Number,
			default: 0
		}
	},

	data() {
		return {
			skipPatient: false,
			showTable: true
		}
	},

	methods: {
		validEmail,
		formatDate,

		// Skip this patient and mark the patient object
		toggleSkipPatient() {
			this.skipPatient = !this.skipPatient
			Vue.set(this.patient, 'skip', this.skipPatient)
		},

		toggleShowTable() {
			this.showTable = ! this.showTable
		},
		skipColumn(column) {
			return column === this.patient.data.email || column === this.patient.data.phone
		}
	},

	watch: {
		email(email) {
			Vue.set(this.patient, 'corrected', validEmail(email))
		}
	},

	computed: {
		...mapGetters('provider', [ 'getProvider', 'getProviderList', 'getProviderNameById']),
		...mapGetters('content', [ 'getContent', 'getContentKey' ]),

		invalidEmail() {
			return ! this.patient.data || ! validEmail(this.patient.data.email)
		},
		providedValidEmail() {
			return validEmail(this.email)
		},
		invalidPatient() {
			return this.invalidEmail && !this.providedValidEmail
		},
		provider() {
			return this.getProvider
		},
		events() {
			return [].concat.apply([], this.provider.profile.map((p) => p.event))
					 .map((id) => this.getContent('event', id))
					 .filter((e) => e != null)
		},
		/**
		 * Names of all the providers by looking through patient event data
		 * for provider Id plus existing provider ids, mapped to names and
		 * joined together
		 * 
		 * @returns {String} Comma separated provider name list
		 */
		patientProviderNames() {
			try {
				/**
				 * List of provider Id's combined from existing and events data
				 * @type {[String]}
				 */
				const providerIdList = [
					// Provider Id's list from `patient.data.existinrProvider`
					...(this.patient.data.existingProvider ? this.patient.data.existingProvider : []),
					// Provider Id's list from event array
					...(this.patient.data.event && Array.isArray(this.patient.data.event) ? 
					this.patient.data.event.map((event) => event.provider).filter((provider) => provider) : [])
				]
				// Uniqueify `providerIdList` and return mapped names, joined
				return [...new Set(providerIdList)].map((providerId) => this.getProviderNameById(providerId)).join(', ')
			} catch (error) {
				console.error('Error in calculating Provider Names ', error)
				return ''
			}
		}
	},

	components: {
		ImportData,
		...Icons
	}
}
